/**
 * Hex-Farbe aufhellen/abdunkeln (percent -1..1; negativ = dunkler).
 * Für white-label-Mandanten: die --oa-primary-dark/-light-Ableitungen werden
 * zur Laufzeit aus der Branding-Farbe berechnet (Layout.tsx), damit
 * Hover-/Akzentzustände zur Mandantenfarbe passen.
 */
export const shadeHexColor = (hex: string, percent: number): string => {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
    if (!m) return hex;
    const num = parseInt(m[1], 16);
    const target = percent < 0 ? 0 : 255;
    const p = Math.abs(percent);
    const mix = (channel: number) => Math.round(channel + (target - channel) * p);
    const r = mix((num >> 16) & 0xff);
    const g = mix((num >> 8) & 0xff);
    const b = mix(num & 0xff);
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
};
